/**************************************************
 * Nombre:       Formulario_ingreso
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined,
    Diamond,
    Flag,
    Google, LockOutline,
    MoveUpOutlined,
    PhoneAndroid,
    TitleOutlined,
    VisibilityOutlined
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {PAISESINDICATIVO} from "../../Modulo_formularios/Recursos/indicativos";
import {RANGOSCUENTA} from "../../Constantes";
import IngresoTextoBoton from "../../Modulo_formularios/Componentes/IngresoTextoBoton";
import {useState} from "react";

const Formulario_ingreso = ({...props}) => {
    const [tipo, settipo] = useState("password");

    const cambiar = () => {

        if (tipo === "text") {
            settipo("password");
        } else {
            settipo("text");
        }
    }

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >



                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={Google} nombre={'Correo'} dato={'correo'} {...props}
                                  requerido={'El correo es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTextoBoton Icono={LockOutline} nombre={'Contraseña'} dato={'pass'} {...props} type={tipo}
                                       requerido={'Campo Requerido'} click={cambiar} IconoFinal={VisibilityOutlined}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_ingreso